import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Gift = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M19.4375 12.2325V18.5001C19.4375 19.6046 18.4861 20.5001 17.3125 20.5001H6.6875C5.51389 20.5001 4.5625 19.6046 4.5625 18.5001V12.2325M19.4375 12.2325V12.0001M19.4375 12.2325C20.0727 11.8867 20.5 11.2403 20.5 10.5001C20.5 9.39549 19.5486 8.50006 18.375 8.50006H5.625C4.45139 8.50006 3.5 9.39549 3.5 10.5001C3.5 11.2403 3.92734 11.8867 4.5625 12.2325M19.4375 12.2325C19.1249 12.4027 18.7621 12.5001 18.375 12.5001H5.625C5.23794 12.5001 4.87506 12.4027 4.5625 12.2325M4.5625 12.0001V12.2325M12 8.50006V6.83339M12 8.50006H10.2292C8.27316 8.50006 6.6875 7.00768 6.6875 5.16673C6.6875 4.24625 7.48033 3.50006 8.45833 3.50006C10.4143 3.50006 12 4.99244 12 6.83339M12 8.50006H13.7708C15.7268 8.50006 17.3125 7.00768 17.3125 5.16673C17.3125 4.24625 16.5197 3.50006 15.5417 3.50006C13.5857 3.50006 12 4.99244 12 6.83339M12 8.50006V20.5001'
        stroke='currentColor'
        strokeWidth='1.5'
      />
    ) : (
      <>
        <path
          d='M6 5.52638C6 4.13113 7.19391 3.00006 8.66667 3.00006C10.007 3.00006 11.2051 3.57653 12 4.48202C12.7949 3.57653 13.993 3.00006 15.3333 3.00006C16.8061 3.00006 18 4.13113 18 5.52638C18 6.34026 17.75 7.09882 17.3188 7.7369H19C20.1046 7.7369 21 8.58521 21 9.63164C21 10.6781 20.1046 11.5264 19 11.5264H13V7.7369H13.6667C14.9553 7.7369 16 6.74722 16 5.52638C16 5.17757 15.7015 4.8948 15.3333 4.8948C14.0447 4.8948 13 5.88448 13 7.10532V7.7369H11V7.10532C11 5.88448 9.95533 4.8948 8.66667 4.8948C8.29848 4.8948 8 5.17757 8 5.52638C8 6.74722 9.04467 7.7369 10.3333 7.7369H11V11.5264H5C3.89543 11.5264 3 10.6781 3 9.63164C3 8.58521 3.89543 7.7369 5 7.7369H6.68121C6.25 7.09882 6 6.34026 6 5.52638Z'
          fill='currentColor'
        />
        <path
          d='M13 13.4211H20V18.158C20 19.7276 18.6569 21.0001 17 21.0001H13V13.4211Z'
          fill='currentColor'
        />
        <path
          d='M11 13.4211H4V18.158C4 19.7276 5.34315 21.0001 7 21.0001H11V13.4211Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
